import * as yup from "yup";

import { Button, Grid } from "@mui/material";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FileInputButton from "../../../../components/fileInputButton";
import FileInputDrop from "../../../../components/fileInputDrop";
import IconButton from "@mui/material/IconButton";
import { Loader } from "./styles";
import { getBase64 } from "../../../../utils/utils";
import messages from "../../../../utils/messages";
import serviceFaturaConcessionaria from "../../../../services/serviceFaturaConcessionaria";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import serviceModeloFatura from "@/services/serviceModeloFatura";
import CheckBox from "@/components/hookForms/checkbox";
import serviceConcessionaria from "@/services/serviceConcessionaria";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
}

export default function DialogLoad({ open, onClose, onSuccess }: IDialogProps) {
    const [modeloDataOptions, setModeloDataOptions] = useState<any[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<any[]>([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileBase64, setSelectedFileBase64] = useState("");
    const [selectedFileListBase64, setSelectedFileListBase64] = useState<string[]>([]);
    const [isDisable, setDisable] = useState(false);
    const [isPdf, setIsPdf] = useState(false);
    const [isCsv, setIsCsv] = useState(false);
    const [isXml, setIsXml] = useState(true);
    const [disableField, setDisableField] = useState(true);

    const validationSchema = yup.object().shape({
        modeloFaturaId: !disableField ? yup.string().notRequired() : yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        setValue,
        resetField,
        getValues,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            modeloFaturaId: "",
            concessionaria: "",
            tipoArquivo: "XML",
            flagCapturaFatura: true,
        },
    });

    useEffect(() => {
        setModeloData();
        setConcessionariaData();
    }, []);

    const handleFileInputButton = (e: any) => {
        const extension = e.target.files[0].name.split(".").pop().toLowerCase();

        if (["pdf"].includes(extension) || ["zip"].includes(extension) || ["csv"].includes(extension)) {
            if (isCsv && !["csv"].includes(extension)) {
                toast.error("Tipo de arquivo anexado é diferente do tipo selecionado.");
                setDisable(false);
                return;
            }

            setSelectedFile(e.target.files[0]);

            const size = e.target.files[0].size / 1024 / 1024;

            if (size > 10) {
                toast.error("O tamanho do arquivo selecionado não pode ser maior do que 10MB");
                clearFile();
            }

            getBase64(e.target.files[0]).then((result) => {
                setSelectedFileBase64(result);
            });
        } else {
            toast.error(
                "O arquivo selecionado é inválido. É necessário anexar a fatura no formato 'PDF',  'ZIP (XML)' ou 'CSV'!"
            );
            clearFile();
        }
    };

    const handleFileInputDrop = (selectedFiles: File[]) => {
        let listFileBase64: string[] = [];

        if (selectedFiles) {
            for (const file of selectedFiles as File[]) {
                const size = file.size / 1024 / 1024;

                if (size > 10) {
                    toast.error(
                        "O tamanho do arquivo selecionado não pode ser maior do que 10MB. Arquivo '" + file.name + "'."
                    );
                    clearFile();
                }

                getBase64(file).then((result) => {
                    listFileBase64.push(
                        result
                            .replace("data:application/x-zip-compressed;base64,", "")
                            .replace("data:application/zip;base64,", "")
                    );
                });
            }

            setSelectedFileListBase64(listFileBase64);
        }
    };

    const onSubmit = (values: any) => {
        setDisable(true);

        const modeloFaturaId = getValues().flagCapturaFatura ? Number(values.modeloFaturaId) : 0;

        if (!selectedFile && !selectedFileBase64 && (!selectedFileListBase64 || selectedFileListBase64.length === 0)) {
            toast.error("É necessário anexar o PDF, ZIP (XML) ou CSV da(s) fatura(s).");
            setDisable(false);
        } else {
            if (isPdf) {
                const chargeValues = {
                    ...values,
                    modeloFaturaId,
                    listFilesBase64: selectedFileListBase64,
                };

                serviceFaturaConcessionaria
                    .charge(chargeValues)
                    .then((result) => {
                        if (result) {
                            toast.info("Requisição de importação de PDF gerada com sucesso!");
                            onClose(true);
                            reset();
                            onSuccess();
                            clearFile();
                        }
                    })
                    .finally(() => {
                        setDisable(false);
                        setDisableField(true);
                    });
            } else if (isXml) {
                const chargeValues = {
                    ...values,
                    modeloFaturaId,
                    listFilesBase64: selectedFileListBase64,
                };

                serviceFaturaConcessionaria
                    .chargeXml(chargeValues)
                    .then((result) => {
                        if (result) {
                            toast.info("Requisição de importação de XML gerada com sucesso!");
                            onClose(true);
                            reset();
                            onSuccess();
                            clearFile();
                        }
                    })
                    .finally(() => {
                        setDisable(false);
                        setDisableField(true);
                    });
            } else {
                const chargeValues = {
                    ...values,
                    modeloFaturaId,
                    fileBase64: selectedFileBase64.replace("data:text/csv;base64,", ""),
                };

                serviceFaturaConcessionaria
                    .chargeCsv(chargeValues)
                    .then((result) => {
                        if (result) {
                            toast.info("Requisição de importação de CSV gerada com sucesso!");
                            onClose(true);
                            reset();
                            onSuccess();
                            clearFile();
                        }
                    })
                    .finally(() => {
                        setDisable(false);
                    });
            }
        }
    };

    const setModeloData = async () => {
        serviceModeloFatura
            .getAllModelos()
            .then((result) => {
                setModeloDataOptions(result?.data);
            })
            .catch(() => {
                setModeloDataOptions([]);
            });
    };

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(
                    result?.data?.map((data) => {
                        return { label: data.label, value: data.label };
                    })
                );
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const onCancelLoad = () => {
        clearFile();
        reset();
        setDisableField(true);
        onClose(true);
    };

    const clearFile = () => {
        setSelectedFile(null);
        setSelectedFileBase64("");
        setSelectedFileListBase64([]);
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Carregar Fatura
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            onCancelLoad();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            {isDisable && (
                                <Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </Loader>
                            )}
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <CheckBox
                                name="flagCapturaFatura"
                                label="Utiliza o Módulo de Captura de Faturas?"
                                control={control}
                                error={errors}
                                onClick={() => {
                                    setDisableField(!disableField);
                                    resetField("concessionaria");
                                    resetField("modeloFaturaId");
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <AutoComplete
                                id="modeloFaturaId"
                                name="modeloFaturaId"
                                label="Modelo"
                                options={modeloDataOptions?.map((data) => {
                                    return { value: data.modeloFaturaId, label: data.descricaoModelo };
                                })}
                                onChange={(id) => {
                                    const modelo = modeloDataOptions.find((modelo) => modelo.modeloFaturaId === id);
                                    if (modelo.nomeConcessionaria) {
                                        setValue("concessionaria", modelo.nomeConcessionaria);
                                    }
                                }}
                                onInputChange={(_, __, reason) => {
                                    if (reason === "clear") {
                                        resetField("concessionaria");
                                    }
                                }}
                                control={control}
                                error={errors}
                                disabled={!disableField}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <AutoComplete
                                id="concessionaria"
                                name="concessionaria"
                                label="Concessionária"
                                options={concessionariaDataOptions}
                                control={control}
                                error={errors}
                                disabled={disableField}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <AutoComplete
                                id="tipoArquivo"
                                name="tipoArquivo"
                                label="Tipo de arquivo"
                                options={[
                                    { value: "XML", label: "ZIP (XML)" },
                                    { value: "PDF", label: "PDF" },
                                    { value: "CSV", label: "CSV" },
                                ]}
                                control={control}
                                error={errors}
                                onChange={(value) => {
                                    if (value === "XML") {
                                        setIsXml(true);
                                        setIsPdf(false);
                                        setIsCsv(false);
                                    }
                                    if (value === "PDF") {
                                        setIsPdf(true);
                                        setIsXml(false);
                                        setIsCsv(false);
                                    }
                                    if (value === "CSV") {
                                        setIsCsv(true);
                                        setIsPdf(false);
                                        setIsXml(false);
                                    }
                                }}
                            />
                        </Grid>
                        {isXml && (
                            <Grid item xs={12} md={12}>
                                <FileInputDrop accept="application/zip" onDrop={handleFileInputDrop} />
                            </Grid>
                        )}
                        {isPdf && (
                            <Grid item xs={12} md={12}>
                                <FileInputDrop accept="application/pdf" onDrop={handleFileInputDrop} />
                            </Grid>
                        )}
                        {isCsv && (
                            <Grid item xs={12} md={12}>
                                <FileInputButton
                                    accept="text/csv"
                                    onChange={handleFileInputButton}
                                    selectedFile={selectedFile}
                                />
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={() => onCancelLoad()}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Carregar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
